import type { ParsedUrlQuery } from 'querystring';
import { ShareType } from '../shareTypes';
import type { ShareProps } from '../shareTypes';
import {
  toClassDetailsProps,
  toScheduleEventDetailsProps,
  toDetailedWorkoutDetailsProps,
  toTagDetailsProps,
  toInviteDetailsProps,
  toGenericWorkoutProps,
} from './models';

export const toShareProps = <T extends ShareType>(
  shareType: T,
  query: ParsedUrlQuery,
): ShareProps[T] => {
  switch (shareType) {
    case ShareType.ClassDetails:
      return toClassDetailsProps(query) as ShareProps[T];
    case ShareType.TagDetails:
      return toTagDetailsProps(query) as ShareProps[T];
    case ShareType.ScheduleEventDetails:
      return toScheduleEventDetailsProps(query) as ShareProps[T];
    case ShareType.DetailedWorkoutDetails:
      return toDetailedWorkoutDetailsProps(query) as ShareProps[T];
    case ShareType.InviteDetails:
      return toInviteDetailsProps(query) as ShareProps[T];
    case ShareType.GenericWorkoutDetails:
      return toGenericWorkoutProps(query) as ShareProps[T];
    default:
      return {} as ShareProps[T];
  }
};
